import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import { Link as ReactRouterLink } from '@ksyos/router';
import { BackgroundImageTemplate } from '@frontend/components/templates/BackgroundImageTemplate';
import { getSelectedLanguage } from '@frontend/translate';

export function NotFoundError() {
    const errorPageTranslation = getSelectedLanguage().errorPages;

    return (
        <BackgroundImageTemplate>
            <Heading
                mb={6}
                size="xlarge"
            >
                {errorPageTranslation.notFoundTitle}
            </Heading>
            <Text mb={6}>{errorPageTranslation.notFoundBody}</Text>
            <ButtonRow isStackedBelowSmall={true}>
                <Button
                    as={ReactRouterLink}
                    color="secondary"
                    iconLeft="home"
                    to="/home"
                >
                    {errorPageTranslation.goToHome}
                </Button>
                <Button
                    as={ReactRouterLink}
                    color="secondary"
                    iconLeft="search"
                    to="/patients"
                >
                    {errorPageTranslation.goToPatients}
                </Button>
            </ButtonRow>
        </BackgroundImageTemplate>
    );
}
